// extracted by mini-css-extract-plugin
export default {"hideTooltip":"y--z","fadeIn":"z--z","delay":"A--z","recommendedSizeTooltip":"B--z"};